// Characters carriers can encode in 7 bits. Anything outside this set forces the whole message into
// UCS-2, which more than halves how much fits in a segment.
const GSM_7_BASIC = '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà';

// These are encodable, but each one occupies two of the seven-bit slots. Listed as characters rather
// than one string literal so the backslash cannot be lost to escaping.
const GSM_7_EXTENDED = ['^', '{', '}', '\\', '[', '~', ']', '|', '€'];

/**
 * Rough length of the branding prefix and the "Reply STOP to opt out." notice the template wraps
 * around a broadcast. The exact figure depends on the configured sender name, so this is only used to
 * keep the estimate from reading lower than what is actually sent.
 */
export const BROADCAST_TEMPLATE_OVERHEAD = 45;

function isGsm7(message) {
    return [...message].every((character) => GSM_7_BASIC.includes(character) || GSM_7_EXTENDED.includes(character));
}

function gsm7Length(message) {
    return [...message].reduce((total, character) => total + (GSM_7_EXTENDED.includes(character) ? 2 : 1), 0);
}

/**
 * Estimates how many billed segments a message will use.
 *
 * Each segment is charged separately, so this is what turns a long broadcast into a surprisingly
 * large bill.
 * @param message {string}
 * @returns {number}
 */
export function estimateSegments(message) {
    if (!message) {
        return 0;
    }

    const isUnicode = !isGsm7(message);
    const singleSegmentLimit = isUnicode ? 70 : 160;
    const multiSegmentLimit = isUnicode ? 67 : 153;
    const length = isUnicode ? [...message].length : gsm7Length(message);

    return length <= singleSegmentLimit ? 1 : Math.ceil(length / multiSegmentLimit);
}
